// extracted by mini-css-extract-plugin
export var section = "_24-1";
export var topNav = "_24-0";